import React from 'react'
import {useContext} from 'react';
import {PortfolioContext} from '../../contexts/recentsWorks';
import ProjectCard from './ProjectCard';
import Loading from '../Loading';
import Grid from '@material-ui/core/Grid';

export default function ProjectsList() {
    const context = useContext(PortfolioContext);
    const {loading, otherProjects} = context;

    return (
        <div className='text-left projectsList'>
            <h4>Other Projects</h4>
            {loading
                ? <Loading/>
                : <Grid container className='text-center'>
                    {otherProjects.map((item, index) => {
                        return <Grid key={index} item xs={6} sm={6} md={4}>
                                <ProjectCard
                                   key={index}
                                   name={item.name}
                                   description={item.description}
                                   featured={item.featured}
                                   forSale={item.forSale}
                                   images={item.images}
                                   saleCover={item.saleCover}
                                   slug={item.slug}
                                   />
                        </Grid>
                    })
        }
                </Grid>
}
        </div>
    )
}
